<p>
  <ng-content></ng-content>
  <span> Please login to your account at <a [href]="url" (click)="$event.preventDefault(); redirectToBrowser()"> {{ host }}</a> from a computer to manage your account.</span>
</p>
